
import { Component, OnInit } from '@angular/core';
import {Inject} from '@angular/core';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectImage, ProjectMaterial } from 'src/app/objects/Project';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectImageService } from 'src/app/Services/projectImages..service';

@Component({
  selector: 'app-project-image-popup',
  templateUrl: './project-image-popup.component.html',
  styleUrls: ['./project-image-popup.component.css']
})

export class ProjectImagePopupComponent implements OnInit {
 

  ProjectId: number | undefined ;
  project: Project |any;
  searchTerm: string = '';
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 

  items: any[] = [];
  projectImage: ProjectImage |any;
  // ProjectMaterials: ProjectMaterial []=[];
  sortProperty: string = 'id';
  sortOrder = 1;
  sortListProperty: string = 'id';
  sortListOrder = 1;
  ProjectObject?: Project []=[];

  durationInSeconds = 5;
  constructor( private route: ActivatedRoute,  private router: Router,
    private materialsService: MaterialsService,
    private projectImageService: ProjectImageService,
    private projectService: ProjectService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ProjectImagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
    ) {  
     } 

     
     ngOnInit(): void {
    
      if (this.data != undefined) {
         
        this.loadProjectImage(this.data.id);
      } 
    }
  
    loadProjectImage(id:number) {
      this.projectImageService.getImage(id).subscribe((ProjectImage) => {
        this.projectImage = ProjectImage; 
        
      });
    }
    }